function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { usePrefixCls } from '@byte-design/config';
export function TableCellData(props) {
  var _usePrefixCls, _usePrefixCls2;

  var _props$align = props.align,
      align = _props$align === void 0 ? 'left' : _props$align,
      _props$valign = props.valign,
      valign = _props$valign === void 0 ? 'center' : _props$valign,
      _props$ellipsis = props.ellipsis,
      ellipsis = _props$ellipsis === void 0 ? false : _props$ellipsis,
      _props$maxLine = props.maxLine,
      maxLine = _props$maxLine === void 0 ? 1 : _props$maxLine,
      children = props.children;
  var isBox = ellipsis === true && maxLine > 1;
  var cls = usePrefixCls('table-td', (_usePrefixCls = {}, _defineProperty(_usePrefixCls, align, !isBox), _defineProperty(_usePrefixCls, valign, true), _defineProperty(_usePrefixCls, "ellipsis", ellipsis === true && maxLine === 1), _usePrefixCls));
  var boxCls = usePrefixCls('table-td', (_usePrefixCls2 = {
    box: true
  }, _defineProperty(_usePrefixCls2, align, true), _defineProperty(_usePrefixCls2, "line", ellipsis === true && maxLine > 1 ? maxLine : false), _usePrefixCls2), true);

  if (isBox) {
    return React.createElement("div", {
      className: cls
    }, React.createElement("div", {
      className: boxCls
    }, children));
  }

  return React.createElement("div", {
    className: cls
  }, children);
}